import { skipToken } from '@tanstack/react-query';
import { useState } from 'react';
import { Protocol } from '../types/sharedTypeImpl.ts';
import { formatDate } from '../utils/fieldFormats.ts';
import { trpc } from '../utils/trpc/trpc.ts';
import { LinkButton } from './linkButton.tsx';
import { ModalDialog } from './modalDialog.tsx';
import { ProtocolChangesDialog } from './protocol-changes-dialog/protocolChangesDialog.tsx';


interface Props {
    isOpen: boolean;
    protocol: Protocol;
    onClose: () => void;
}

export function ProtocolVersionsDialog({
    isOpen,
    protocol,
    onClose,
}: Props) {

    const [changesDialogState, setChangesDialogState] = useState<Protocol[] | null>(null);


    const { data: prevProtocols, isLoading } = trpc.protocols.get.useQuery(
        (protocol.partName && protocol.partRevision) ? {
            partName: protocol.partName,
            partRevision: protocol.partRevision,
            status: 'approved',
            ...(protocol.createTime && { createTime: { end: protocol.createTime } }),
            sort: { version: -1 },
        } : skipToken,
    );

    const protocolsAll = [protocol, ...(prevProtocols || [])];
    const protocolsFinal = protocolsAll.map((protocol, index) => ({
        ...protocol,
        prevProtocol: index < protocolsAll.length - 1 ? protocolsAll[index + 1] : null,
    }));

    return <>
        <ModalDialog
            isOpen={isOpen}
            onCancel={onClose}
        >
            <table className='table__small-padding' style={{ width: '800px' }}>
                <thead>
                    <tr>
                        <td>Version</td>
                        <td>Changes</td>
                        <td>Date</td>
                        <td>Creator</td>
                        <td />
                    </tr>
                </thead>
                <tbody>
                    {isLoading && <tr><td colSpan={4}>Loading...</td></tr>}

                    {!isLoading && protocolsFinal.map((protocol, index) => (
                        <tr key={index}>
                            <td>{protocol.version}</td>
                            <td>{protocol.changes}</td>
                            <td>{formatDate(protocol.createTime)}</td>
                            <td>{protocol.user}</td>
                            <td>
                                {index < protocolsFinal.length - 1
                                    && <LinkButton
                                        onClick={() => setChangesDialogState([protocol, protocol.prevProtocol!])}
                                        children='Compare'
                                    />}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <LinkButton
                style={{ float: 'right', marginTop: '16px' }}
                onClick={() => setChangesDialogState(protocolsAll)}
                children='Compare all changes'
            />
        </ModalDialog>

        {changesDialogState && <ProtocolChangesDialog
            protocols={changesDialogState}
            onClose={() => setChangesDialogState(null)}
        />}
    </>;
}
